import { useSyncExternalStore } from 'react'

let now = Date.now()
let timer: ReturnType<typeof setInterval> | undefined
const listeners = new Set<() => void>()

function subscribe(listener: () => void) {
  listeners.add(listener)
  if (!timer) {
    timer = setInterval(() => {
      now = Date.now()
      for (const notify of listeners) notify()
    }, 1_000)
  }
  return () => {
    listeners.delete(listener)
    if (!listeners.size && timer) {
      clearInterval(timer)
      timer = undefined
    }
  }
}

const snapshot = () => now

export function LiveTimestamp({ value, fallback = 'Publication time unknown', compact = false }: { value?: string; fallback?: string; compact?: boolean }) {
  const current = useSyncExternalStore(subscribe, snapshot, snapshot)
  if (!value || Number.isNaN(new Date(value).getTime())) return <span className="live-timestamp live-timestamp--unknown">{fallback}</span>
  const exactSeconds = Math.max(0, Math.floor(Math.abs(current - new Date(value).getTime()) / 1_000))
  const future = new Date(value).getTime() > current
  return <time className={`live-timestamp${compact ? ' live-timestamp--compact' : ''}`} dateTime={value} title={formatAbsoluteTime(value)}>
    <span>{formatAbsoluteTime(value)}</span>
    <small>{formatAge(exactSeconds, future)} · {exactSeconds.toLocaleString('en-IN')} seconds {future ? 'from now' : 'ago'}</small>
  </time>
}

export function formatAbsoluteTime(value?: string) {
  if (!value) return 'Unknown'
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return 'Unknown'
  return new Intl.DateTimeFormat('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit',
    timeZone: 'Asia/Kolkata', timeZoneName: 'short',
  }).format(parsed)
}

export function formatAge(seconds: number, future = false) {
  const days = Math.floor(seconds / 86_400)
  const hours = Math.floor((seconds % 86_400) / 3_600)
  const minutes = Math.floor((seconds % 3_600) / 60)
  const remainder = seconds % 60
  const parts = days > 0 ? [`${days}d`, `${hours}h`, `${minutes}m`] : hours > 0 ? [`${hours}h`, `${minutes}m`, `${remainder}s`] : minutes > 0 ? [`${minutes}m`, `${remainder}s`] : [`${remainder}s`]
  return future ? `in ${parts.join(' ')}` : `${parts.join(' ')} ago`
}
